import React, { Component } from 'react';
import GroupList from './GroupList';
import PantallaCambioMasivo from './PantallaCambioMasivo';

const groupBy = function (xs, key) {
    return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};

const PantallaElegida = ({ pantalla, selectedGroups, elegido, seleccionarGrupo, selectedKey, total, cambiarEstadoFn, estados, siguientes, tiposPlastico, tipoId }) => {

    if (pantalla === 'GroupList')
        return (
            <GroupList
                seleccionados={selectedGroups}
                seleccionarFn={seleccionarGrupo}
                total={total}
                estados={estados}
                tiposPlastico={tiposPlastico}
                siguientes={siguientes}
            />
        );

    if (pantalla === 'CambioMasivo')
        return <PantallaCambioMasivo
            estados={estados}
            siguientes={siguientes}
            grupoACambiar={elegido}
            selectedKey={selectedKey}
            cambiarEstadoFn={cambiarEstadoFn}
            estados={estados}
            siguientes={siguientes}
            tipoId={tipoId}
        />;

    return null;
}

class ComponenteCambios extends Component {

    constructor(props) {
        super(props);
        this.state = {
            pantalla: 'GroupList',
            selectedGroup: null,
            selectedKey: -1,
            tipoId: -1
        };
    }

    seleccionarGrupo(key, grupos, tipoId) {
        this.setState({ pantalla: 'CambioMasivo', selectedGroup: grupos, selectedKey: key, tipoId: tipoId });
    }

    render() {

        const { seleccionados, estados, siguientes, tiposPlastico } = this.props;
        const selectedGroups = groupBy(seleccionados, 'estado');
        const total = seleccionados.length;

        return (
        <div className="DropdownContentContainer">

          <div className="CambiarEstadoHeader">
            <p className="Productos-seleccionadosText">
               <span className="Productos-seleccionados-cant">{total}</span> seleccionados &nbsp;
            </p>
          </div>

          <PantallaElegida
             pantalla={this.state.pantalla}
             selectedGroups={selectedGroups}
             elegido={this.state.selectedGroup}
             seleccionarGrupo={this.seleccionarGrupo.bind(this)}
             selectedKey={this.state.selectedKey}
             cambiarEstadoFn={this.props.cambiarEstadoFn}
             total={seleccionados.length}
             estados={estados}
             siguientes={siguientes}
             tiposPlastico={tiposPlastico}
             tipoId={this.state.tipoId}
          />
          
        </div>
        );
    }
}

export default ComponenteCambios;